module.exports = __webpack_public_path__ + "static/media/payment_plan.a621a0e3.svg";